import React from 'react';

function ResetPasswordForm({ email, setEmail, errorMessage, onSubmit }) {
	const handleSubmit = (e) => {
		e.preventDefault();
		onSubmit();
	};

	return (
		<form className="login-form" onSubmit={handleSubmit} noValidate>
			<div className="login-secondary-form">
				<div>
					<h2 className="login-secondary-title">Reset your password</h2>
					<p className="login-secondary-body">Enter your email and we'll send you a reset link.</p>
				</div>
				<div className="login-field" style={{ marginBottom: 0 }}>
					<label className="login-label" htmlFor="reset-email">Email</label>
					<input
						id="reset-email"
						className={`login-input${errorMessage ? ' login-input--error' : ''}`}
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						autoComplete="email"
						required
					/>
					{errorMessage && (
						<div className="login-error" style={{ marginTop: 6, marginBottom: 0 }}>{errorMessage}</div>
					)}
				</div>
				<button type="submit" className="login-submit">Send reset link</button>
			</div>
		</form>
	);
}

export default ResetPasswordForm;
